export default function RecaptchaServiceProvider() {
  this.$get = () => {
    'ngInject';

    function RecaptchaService() {

      const self = this;

      self.execute = (action, callback) => {
        let recaptchaSiteKey = process.env.RECAPTCHA_SITE_KEY;
        grecaptcha.execute(recaptchaSiteKey, {action: action})
          .then(callback);
      }
    }

    return new RecaptchaService();
  };
}